 // Initialize Firebase
 export const DB_CONFIG = {
    apiKey: "AIzaSyB0AbRTl53lWmsP5m3qmP_9el4cXatbjSw",
    authDomain: "inshasgate.firebaseapp.com",
    databaseURL: "https://inshasgate.firebaseio.com",
    projectId: "inshasgate",
    storageBucket: "inshasgate.appspot.com",
    messagingSenderId: "681733036970"
  }; 